<template>
  <div class="container center w100 relative-container">
    <div class="padded">
      <step-counter class="tablet" paso="4" />
      <wrap-container class="cascade w50">
        <form-validator>
          <wrap-container>
            <p
              id="titulo"
              class="titulo p32 medium oscuro"
              v-safe-html="config.pasos.paso4.titulo"
            />
            <div class="subtitulo">
              <p
                id="subtitulo"
                class="titulo oscuro"
                v-safe-html="config.pasos.paso4.subtitulo"
              />
            </div>
          </wrap-container>
          <wrap-container class="container-domicilios">
            <section-label value="¿Dónde querés recibir las tarjetas?" />
            <address-selector
              v-model="model.selectDomicilio"
              :particular="model.domicilioParticular"
              :otro="model.otroDomicilio"
              @cerrar-modal="cerrarModal"
              :required="true"
              analyticsName="modificar"
              quantumObfuscate
              :paquete="true"
            />

            <floating-tip
              description="Este nuevo domicilio lo usaremos solamente para enviarte las tarjetas de crédito"
              :showInfoIcon="true"
              v-if="model.selectDomicilio === 'nuevo'"
            >
            </floating-tip>
          </wrap-container>
          <wrap-container>
            <section-label
              class="elegi-sucursal"
              value="Elegí una sucursal donde va a estar radicada tu cuenta"
            />
            <branch-offices-old
              v-model="model.sucursal"
              :required="true"
              name="sucursal"
              quantumObfuscate
            />
          </wrap-container>
          <wrap-container class="celular">
            <section-label value="Celular" />
            <wrap-container>
              <phone-data v-model="celular" quantumObfuscate />
            </wrap-container>
          </wrap-container>
          <wrap-container>
            <section-label
              value="Indicanos el e-mail al cual podemos enviarte el resumen digital"
            />
            <floating-tip
              class="email-tip"
              :showInfoIcon="true"
              description="Te vamos avisar al mail ingresado cuando
                          tu resúmen esté diponible en el homebanking."
            >
              <email-field
                class="email"
                name="email"
                v-model="model.email"
                :required="true"
                analyticsName="email"
                :analyticsTypology="config.analyticsTypology"
                quantumObfuscate
              />
            </floating-tip>
          </wrap-container>
          <step-navigator
            v-model="model"
            :store-action="this.doNext"
            analyticsName="finalizar"
          />
        </form-validator>
      </wrap-container>
      <wrap-container class="cascade w50"></wrap-container>
      <documentation-detail v-if="showModal" @close="showModal = false" />
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import FormValidator from "@/components/core/FormValidator";
import PhoneData from "@/components/core/PhoneData";
import AddressSelector from "@/components/core/custom/AddressSelector";
import DocumentationDetail from "@/components/core/modals/DocumentationDetail";
import StepCounter from "@/components/core/StepCounter";
import SectionLabel from "@/components/core/SectionLabel";
import FloatingTip from "@/components/core/custom/FloatingTip";
import StepNavigator from "@/components/core/StepNavigator";
import { DO_CONFIRMAR_DATA } from "../config/constants/action-types";
import BranchOfficesOld from "@/components/core/composite/combos/BranchOfficesOld";
import EmailField from "@/components/core/EmailField";

export default {
  name: "Paso4",
  components: {
    WrapContainer,
    FormValidator,
    PhoneData,
    AddressSelector,
    DocumentationDetail,
    StepCounter,
    SectionLabel,
    FloatingTip,
    StepNavigator,
    BranchOfficesOld,
    EmailField
  },
  data() {
    return {
      showModal: false,
      celular: this.$store.getters.getConsulta().celular,
      model: this.$store.getters.getPaso4(),
      doNext: DO_CONFIRMAR_DATA
    };
  },
  mounted() {
    /* Si no hay oferta... Vuelvo a la consulta */
    if (PRODUCTION && !this.$store.state.dataOferta.oferta.valid) {
      this.$router.push("/");
    }

    this.$store.watch(
      this.$store.getters.getPaso4,
      model => {
        this.model = model;
      },
      { immediate: true }
    );
  },
  methods: {
    cerrarModal(valid) {
      if (
        !valid &&
        this.model.otroDomicilio &&
        this.model.otroDomicilio.valido !== true
      ) {
        this.model.selectDomicilio = "particular";
      }
    }
  }
};
</script>

<style scoped>
.cobranding-logo-header {
  top: 36px;
}
.subtitulo {
  font-size: 15px;
  line-height: 1.3em;
}
.container-domicilios {
  margin-top: 30px;
  margin-bottom: 0px;
}

#titulo {
  margin-bottom: 15px;
}

#subtitulo {
  margin-bottom: 45px;
}

.address {
  margin-bottom: 20px;
}

.celular {
  margin-top: 32px;
  margin-bottom: 30px;
}

.email {
  margin-top: 16px;
  padding-bottom: 20px;
}

.email-tip {
  width: 50%;
}

.elegi-sucursal {
  margin-top: -20px;
}

@media screen and (max-width: 600px) {
  .elegi-sucursal {
    margin-top: 40px;
  }
  .email-tip {
    width: 100%;
  }
  .email {
    width: 100%;
  }
  .celular {
    margin-top: 40px;
  }
}

@media screen and (min-width: 601px) and (max-width: 1024px) {
  .w50 {
    width: 80%;
    max-width: 1024px;
    margin-left: 10%;
    margin-right: 10%;
  }

  .cascade {
    display: block;
  }

  .tablet {
    margin-left: 10%;
  }
}
</style>
